import useSoldSerial from "@/hooks/useSoldSerials";
import MainLayout from "@/shared/components/MainLayout";
import Header from "@/shared/components/ui/Header";
import { motion } from 'framer-motion';
import { Hash, Layers, Loader, Tag } from "lucide-react";
import { useTranslation } from "react-i18next";


const SoldSerials = () => {
    const { t } = useTranslation();
    const {
        name,
        isLoading,
        soldSerials,
        soldSerialsQuery,
        handlePrint
    } = useSoldSerial();

    return (
        <MainLayout>
            <Header title={`${t('Sold serials')} / ${decodeURIComponent(name || '')}`} info={soldSerialsQuery} />
            <main className="px-4 py-8 min-h-[calc(100vh-100px)] flex flex-col items-center justify-center">
                <div className="w-full max-w-5xl">
                    {isLoading ? (
                        <div className="flex justify-center py-20">
                            <Loader />
                        </div>
                    ) : (
                        <div className="bg-white rounded-[1rem] border border-slate-200 shadow-xl shadow-slate-200/50 overflow-hidden">
                            <div className="overflow-x-auto">
                                <table className="w-full border-collapse">
                                    <thead>
                                        <tr className="text-slate-400 uppercase text-[11px] font-black tracking-widest border-b border-slate-100">
                                            <th className="px-6 py-4 text-start">
                                                <div className="flex items-center gap-2">
                                                    <Tag size={14} className="text-violet-500" />
                                                    {t("serial_string")}
                                                </div>
                                            </th>
                                            <th className="px-6 py-4 text-start">
                                                <div className="flex items-center gap-2">
                                                    <Layers size={14} className="text-violet-500" />
                                                    {t("remaning_quantity")}
                                                </div>
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-50">
                                        {soldSerials.length > 0 ? (
                                            soldSerials.map((item, index: number) => (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ delay: index * 0.05 }}
                                                    className="hover:bg-violet-50/30 transition-colors group"
                                                >
                                                    <td className="px-6 py-5">
                                                        {item?.serial_string}
                                                    </td>
                                                    <td className="px-6 py-5">
                                                        {item?.remaning_quantity}
                                                    </td>
                                                </motion.tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={3} className="px-6 py-20 text-center">
                                                    <div className="flex flex-col items-center gap-3 opacity-20">
                                                        <Hash size={48} />
                                                        <p className="font-black uppercase tracking-widest text-sm">{t("No Data Found")}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    <div className="flex justify-end mt-5"
                    >
                        <button
                            onClick={handlePrint}
                            className="flex items-center gap-2 px-6 py-2.5 bg-violet-600 hover:bg-violet-700 text-white font-bold rounded-xl shadow-lg shadow-violet-200 transition-all active:scale-95 group"
                        >{t("print")}
                        </button>
                    </div>
                </div>
            </main>
        </MainLayout>
    )
}

export default SoldSerials;